// PostHog is initialized in src/lib/posthog.ts (bundled posthog-js).
import { posthog } from '../lib/posthog'

// Tier 1 — Core Business Value
export const EVENTS = {
  // Auth
  USER_SIGNED_UP: 'user_signed_up',
  USER_SIGNED_IN: 'user_signed_in',
  ONBOARDING_COMPLETED: 'onboarding_completed',

  // Core Ops
  TRIP_CREATED: 'trip_created',
  TRIP_LEG_ADDED: 'trip_leg_added',
  CREW_ASSIGNED_TO_LEG: 'crew_assigned_to_leg',
  ROSTER_ENTRY_CREATED: 'roster_entry_created',
  CREW_MEMBER_INVITED: 'crew_member_invited',
  ANNOUNCEMENT_SENT: 'announcement_sent',

  // Tier 2 — Feature Adoption
  AIRCRAFT_CREATED: 'aircraft_created',
  PAX_CREATED: 'pax_created',
  DOCUMENT_UPLOADED: 'document_uploaded',
  MESSAGE_SENT: 'message_sent',
  ASSISTANT_MESSAGE_SENT: 'assistant_message_sent',

  // FBO / handling agents
  FBO_FETCHED: 'fbo_fetched',
  FBO_SELECTED: 'fbo_selected',
  AIRPORT_DETAIL_VIEWED: 'airport_detail_viewed',
} as const

type EventName = (typeof EVENTS)[keyof typeof EVENTS]

export function track(event: EventName, properties?: Record<string, unknown>) {
  posthog.capture(event, properties)
}

export function identifyUser(
  userId: string,
  properties?: { email?: string; name?: string; role?: string; companyId?: string }
) {
  posthog.identify(userId, properties)
}

export function resetUser() {
  posthog.reset()
}

// `$screen` + `$screen_name` matches what the native SDK emitted, so existing
// insights keep working.
export function trackScreen(screenTitle: string, properties?: Record<string, unknown>) {
  posthog.capture('$screen', { $screen_name: screenTitle, ...properties })
}
